module.exports = "'data:image/svg+xml;utf8,<svg width=\"12\" height=\"7\" viewBox=\"0 0 12 7\" xmlns=\"http://www.w3.org/2000/svg\"><title>arrow</title><path d=\"M9.877.329a1.128 1.128 0 0 1 1.588.002c.443.443.44 1.15.003 1.589L6.69 6.698a1.118 1.118 0 0 1-.79.326 1.104 1.104 0 0 1-.796-.326L.326 1.92A1.128 1.128 0 0 1 .328.331 1.12 1.12 0 0 1 1.917.33l3.98 3.98 3.98-3.98z\" fill=\"%23C3CDD7\" fill-rule=\"evenodd\"/></svg>'"


//////////////////
// WEBPACK FOOTER
// ./src/Components/SampleToggle/arrowExpanded.svg
// module id = 630
// module chunks = 0